// extracted by mini-css-extract-plugin
export default {"container":"styles_container__t2V6P","action_section":"styles_action_section__mbi3r"};